import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextareaMixin } from '../../mixins/components/TextareaMixin';
import { FormControl } from '../FormControl/FormControl';

/**
 * A basic [HTML textarea element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea).
 *
 * @since 3.0.0
 */
var Textarea = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Textarea",
  componentId: "c11n-8-111-0__sc-ulc0xn-0"
})(["", ""], TextareaMixin);
Textarea.displayName = 'Textarea';
Textarea.propTypes = {
  /**
   * Displays the textarea in an error state. Can also be inherited from a FormField parent.
   */
  error: PropTypes.bool,
  /**
   * Textareas are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the textarea's width is set to `auto`.
   */
  fluid: PropTypes.bool,
  /**
   * The [native textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
   * "maxlength" property.
   */
  maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Determines whether the user can resize the textarea and in which directions.
   * Controls the CSS `resize` property.
   */
  resize: PropTypes.oneOf(['both', 'horizontal', 'vertical', 'none']),
  /**
   * The [native textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
   * "rows" property.
   */
  rows: PropTypes.string,
  /**
   * Indicates the textarea is required. Can also be inherited from a FormField parent.
   */
  required: PropTypes.bool,
  /**
   * Displays the textarea in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: PropTypes.bool,
  /**
   * styled-components forwarded `as` component.
   * @ignore
   */
  forwardedAs: PropTypes.string,
  /**
   * Displays the textarea in a read-only state. Can also be inherited from a FormField parent.
   *
   * @since 8.27.0
   */
  readOnly: PropTypes.bool
};
Textarea.defaultProps = {
  fluid: true,
  resize: 'none',
  rows: '3',
  forwardedAs: 'textarea'
};

/** @component */
export { Textarea };